import { Cookie } from '@pkg/classes';

export enum AttributionEnum {
    utm_source = 'utm_source',
    utm_content = 'utm_content',
    utm_campaign = 'utm_campaign',
    utm_medium = 'utm_medium',
    utm_term = 'utm_term',
    gclid = 'gclid',
    // These are set when user hits a landing page or makes a purchase
    partner = 'partner',
    partner_name = 'partner_name',
    // These are set when user hits a landing page
    acquisition_utm_source = 'acquisition_utm_source',
    acquisition_utm_medium = 'acquisition_utm_medium',
    acquisition_utm_campaign = 'acquisition_utm_campaign',
}

export type AttributionProperties = {
    [key in AttributionEnum]?: string;
};

export function getAttributionProperties(): AttributionProperties {
    const attributionProperties: AttributionProperties = {};

    Object.keys(AttributionEnum).forEach((key) => {
        const cookieValue = Cookie.getValue(key);

        if (cookieValue) {
            attributionProperties[key] = cookieValue;
        }
    });

    return attributionProperties;
}

/**
 * Set only those attribution properties that haven't been saved
 * previously and save them in the cookie.
 *
 * This is done in order to keep source of truth:
 * If user came from Facebook, his 'utm_source' is 'facebook',
 * and if later on the user comes from clicking a link on a celebrity page,
 * the user's 'utm_source' should still be 'facebook' and not 'celebrity'.
 *
 * @param attributionProperties
 */
export function setAttributionProperties(attributionProperties: AttributionProperties) {
    const storedAttributionProperties = getAttributionProperties();
    const yatDomain =
        process.env.NODE_ENV === 'production' ? 'y.at' : process.env.NODE_ENV === 'development' ? 'yat.fyi' : 'yat.rip';

    Object.keys(attributionProperties).forEach((property) => {
        if (!storedAttributionProperties[property]) {
            storedAttributionProperties[property] = attributionProperties[property];
        }
    });

    Object.keys(attributionProperties).forEach((key) => {
        Cookie.set({
            name: key,
            value: attributionProperties[key],
            domain: yatDomain,
            // Set cookie duration to 30 days
            duration: 2592000,
        });
    });
}
